const SERVICE = 'customer'

const addresses = async api => api.setMethod().get().setService(SERVICE).process('/addresses')

module.exports = {
  addresses,
}
